module.exports = __webpack_public_path__ + "b2889bf492d77317e58c46dbd6e24a75.MP3";